import { useMutationTE, UseMutationTEResult } from 'utils/react-query';
import { SubscriptionRequestBody, updateSubscriptionTE } from 'api/users/subscription';
import { errorToReactLeft } from 'utils/fp';
import { either } from 'fp-ts';
import { ReactLeft } from 'utils/uiStates/uiStates';

type UserSubscriptionMutationProps = {
  userId: string;
  onSuccess?: (data: CF.API.Users.SubscriptionResponse) => void;
  onError?: (error: ReactLeft) => void;
};

export const useUserSubscriptionMutation = ({
  userId,
  onSuccess,
  onError,
}: UserSubscriptionMutationProps): UseMutationTEResult<
  ReactLeft,
  CF.API.Users.SubscriptionResponse,
  either.Left<ReactLeft>,
  either.Right<CF.API.Users.SubscriptionResponse>,
  SubscriptionRequestBody
> => {
  const res = useMutationTE((body: SubscriptionRequestBody) => updateSubscriptionTE({ userId, body }, errorToReactLeft)(), {
    onSuccess,
    onError,
  });
  return res;
};
